/**
 * SEO Sprint 2 — Destination page: Bonaire (/shipping-to-bonaire).
 * CMS-driven via `destination_page_settings` slug=bonaire.
 */
import React from "react";
import DestinationPage from "../components/DestinationPage";

const BONAIRE_FALLBACK = {
  display_name: "Bonaire",
  country_code: "BQ",
  url_path: "/shipping-to-bonaire",
  page_banner: {
    eyebrow: "Bestemming: Bonaire",
    title: "Verzenden naar",
    highlight: "Bonaire",
    subtitle:
      "Zend pakketten en cargo naar Bonaire via onze zee- of luchtvrachtroutes. Documenten, pickup en aflevering op Bonaire — wij regelen het hele traject.",
    badges: [
      { icon: "ship",    label: "Zee- en luchtvracht" },
      { icon: "package", label: "Pakketten t/m cargo" },
      { icon: "support", label: "Persoonlijke begeleiding" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Over verzendingen naar Bonaire",
    title: "Hoe wij uw zending naar Bonaire regelen",
    body:
      "Voor zendingen naar Bonaire stemmen wij de route af op het type goederen, het volume en uw planning. Pakketten, kleine zendingen en spoedgoederen gaan vaak via de lucht; verhuis- en bulkzendingen kiezen meestal voor zeevracht. Wij verzorgen pickup in Nederland, documenten, douane-formaliteiten en lokale aflevering op Bonaire.\n\nBeschikbaarheid, tarieven en procedures kunnen per bestemming en type zending verschillen. Vraag actuele routebeschikbaarheid aan — onze medewerkers helpen u graag met de juiste verzendoptie.",
  },
  service_blocks: { items: [] },
  faq: { items: [] },
  cta_band: {
    title: "Klaar om naar Bonaire te verzenden?",
    description:
      "Vraag een vrijblijvende offerte aan met uw zendingdetails — wij adviseren binnen 1 werkdag de juiste route, kosten en documenten.",
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  seo: {
    title: "Pakket naar Bonaire sturen | Zee- en luchtvracht | 5999Cargo",
    description:
      "Verzend pakketten en cargo van Nederland naar Bonaire. Zee- of luchtvracht, persoonlijke begeleiding van pickup tot aflevering.",
    keywords:
      "pakket naar Bonaire sturen, zeevracht Bonaire, luchtvracht Bonaire, vracht naar Bonaire, shipping to Bonaire from Netherlands",
  },
};

export default function ShippingToBonairePage() {
  return <DestinationPage slug="bonaire" fallback={BONAIRE_FALLBACK} />;
}
